var pug = require("!../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (value) {if (value) {
pug_html = pug_html + "\u003Cspan class=\"performance-metrics-value\"\u003E" + (pug.escape(null == (pug_interp = value.metricValue) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan class=\"performance-metrics-insight\"\u003E";
if (value.hasInsight) {
pug_html = pug_html + "\u003Cspan" + (" class=\"iconba iconba-Insights clickable\""+" tabindex=\"0\" role=\"button\""+pug.attr("data-item-index", value.itemIndex, true, true)+pug.attr("data-metric-value", value.metricValue, true, true)) + "\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + "\u003C\u002Fspan\u003E";
}
else {
pug_html = pug_html + (pug.escape(null == (pug_interp = '-') ? "" : pug_interp));
}}.call(this,"value" in locals_for_with?locals_for_with.value:typeof value!=="undefined"?value:undefined));;return pug_html;};
module.exports = template;